var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"main-content"},[_c('TopNav'),_c('el-container',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.ready),expression:"!ready"}]},[_c('el-container',[_c('el-main',[(_vm.ready)?_c('router-view'):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }